import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setSavingWorkingProjectErrorReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string | null>) => {
    state.savingWorkingProjectError = action.payload;
    state.saveId = null;
    state.refetchProjectAfterSave = false;
  });
};

export default setSavingWorkingProjectErrorReducer;
